module.exports = __webpack_public_path__ + "static/media/before_service2.0421be5f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/hymns/before_service2.pdf
// module id = 781
// module chunks = 2